import React from 'react'
import '../../graphStyles.scss'

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
  import { Bar } from 'react-chartjs-2'
  
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  )




/**
 * Made up data to be replaced
 */
const labels = [
    'Age (45-64)',
    'Gender (Female)',
    'State (NY, TX)',
    'Device (Andriod)',
    'Day of Week (Sat)',
    'Time of Day (evening)',
    'Word Group 1 (Environmentall Friendly)',
    'Word Group 2 (Traditional Razor)',
    'Word Group 3 (Platinum Coated)',
    'Word Group 4 (Super Saver Pack)'
]

const fakeEngaged = [
    [95], 
    [null, 85], 
    [null, null, 75], 
    [null, null, null, 65], 
    [null, null, null, null, 58],
    [null, null, null, null, null, 50], 
    [null, null, null, null, null, null, 45], 
    [null, null, null, null, null, null, null, 40], 
    [null, null, null, null, null, null, null, null, 35], 
    [null, null, null, null, null, null, null, null, null, 28]
]






export function TopFeaturesEngagedGraph({ features, engaged }) {

  // Uncomment and delete above labels array
  //const labels = features


  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
            filter: (l) => (l.text === 'Engaged Browsing')
        },
        onHover: function (event, legendItem) {
          document.getElementById("chart12").style.cursor = 'pointer'
        },
        onLeave: function (event, legendItem) {
          document.getElementById("chart12").style.cursor = 'default'
        },
      },

    },
    scales: {
        x: {
            title: {
                display: true,
                text: 'List of Features',
                font: {
                    size: 13.5
                }
            },
            grid: {
                display: false
            },
            stacked: true

        },
        y: {
            title: {
              display: true,
              text: 'Number of Engaged Browsing',
              font: {
                size: 13.5
              }
            }
        },   
    },
  }



  const data = {

    // Replace with weeks prop
    labels,

    datasets: [
      {
        label: 'Engaged Browsing',

        // Replace with clicks prop
        // Red
        data: fakeEngaged[0],
        backgroundColor: 'rgba(200, 35, 60)',
      },
      {
        // Light blue
        data: fakeEngaged[1],
        backgroundColor: 'rgba(0, 200, 248)',
      },
      {
        // Yellow
        data: fakeEngaged[2],
        backgroundColor: 'rgba(250, 196, 60)',
      },
      {
        // Teal
        data: fakeEngaged[3],
        backgroundColor: 'rgba(13, 155, 98)',
      },
      {
        // Orange
        data: fakeEngaged[4],
        backgroundColor: 'rgba(209, 150, 98)',
      },
      {
        // Dark Blue
        data: fakeEngaged[5],
        backgroundColor: 'rgba(32, 43, 165, 1)'
      },
      {
        // Pink
        data: fakeEngaged[6],
        backgroundColor: 'rgba(255, 188, 207, 1)'
      },
      {
        // Blue
        data: fakeEngaged[7],
        backgroundColor: 'rgba(150, 136, 255, 1)'
      },
      {
        // Green
        data: fakeEngaged[8],
        backgroundColor: 'rgba(88, 204, 108, 1)'
      },
      {
        // Purple
        data: fakeEngaged[9],
        backgroundColor: 'rgba(175, 100, 184, 1)'
      },
      
    ],
  }



    return (
        <div className='graph'>
            <div className='graph__title'>
                <h4>Top Important Features Based On Engaged Browsing</h4>
            </div>
            <Bar className='chart' id='chart12' options={options} data={data}/>
        </div>
    )
}
